import "./page_title.css";

const PageTitle = (props) => {
  return <p className="module-page-title">{props.title}</p>;
};

export default PageTitle;
